// @flow
import { EventEmitter } from 'events';
import t from '../i18n/I18n';

let i = 1;

/**
 * Represents any type of asynchronous task. Get the status
 * of the task via the `promise` property; abort the task via
 * the `cancel` method.
 *
 * Subclasses should implement the `promise` in their constructor
 * so it is always available.
 *
 * Subclasses must implement the `cancel` method.
 *
 * Extends {@link EventEmitter} for pub/sub convenience.
 */
export default class Job extends EventEmitter {
  _id: number;
  _promise: ?Promise<any>;
  _canceled: boolean;
  _done: boolean;

  constructor() {
    super();
    this._id = i++;
    this._promise = null;
    this._canceled = false;
    this._done = false;
  }

  get id() {
    return this._id;
  }

  get promise() {
    return this._promise;
  }

  get canceled() {
    return this._canceled;
  }

  get done() {
    return this._done;
  }

  get description() {
    const status = this._done ? t('DONE') : this._canceled ? t('CANCELED') : t('RUNNING');
    return {
      label: t('BACKGROUND_TASK') + ` (${status})`,
      tooltip: t('TASK_ID') + `: ${this._id}`,
      status
    };
  }

  cancel() {
    throw new Error('NotImplemented');
  }
}

export type JobSuccessValue = {
  instance: Job,
  response: ?Object | ?(Object[]),
  event: ?Event
};

export type JobFailedValue = {
  instance: Job,
  error: ?Error,
  event: ?Event
};
